import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import React from 'react';

interface Props {
  customSection?: string;
  disablePortal?: boolean;
  displayVisibilityText?: boolean;
  enabled: boolean;
  onChange: () => void;
  section: string;
  small?: boolean;
  stopPropagation?: boolean;
}

const VisibilityToggle: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    customSection = 'room',
    displayVisibilityText = false,
    enabled,
    onChange,
    section,
    small = false,
    stopPropagation = false,
    disablePortal = false,
  } = props;

  const tooltipText = enabled
    ? `shown in ${customSection}. Click to hide.`
    : `hidden in ${customSection}. Click to show.`;

  const handleChange = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation();
    }

    onChange();
  };

  const renderVisibilityText = (): JSX.Element | undefined => {
    if (!displayVisibilityText) {
      return undefined;
    }

    return (
      <Box color={enabled ? 'text.secondary' : 'text.disabled'} mr={0.5}>
        <Tooltip arrow title={`${section} ${tooltipText}`}>
          <Typography color="inherit" variant="body2">
            {enabled ? 'Visible' : 'Hidden'}
          </Typography>
        </Tooltip>
      </Box>
    );
  };

  const iconsSize = small ? 'small' : undefined;

  return (
    <Box alignItems="center" display="flex" mx={-1} onClick={handleChange}>
      {renderVisibilityText()}
      <Tooltip
        arrow
        title={`${section} ${tooltipText}`}
        PopperProps={{
          disablePortal,
        }}
      >
        <IconButton size={iconsSize}>
          {enabled ? (
            <Visibility fontSize={iconsSize} />
          ) : (
            <VisibilityOff fontSize={iconsSize} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default VisibilityToggle;
